import React from 'react';
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
const NewPagination = ({ currentPage, handlePageChange, data, loader }) => {
    const handleNext = () => {
        if (loader || data?.length !== 20) return;
        handlePageChange(currentPage + 1);
    };
    const handlePrev = () => {
        if (loader || currentPage === 1) return;
        if (currentPage > 1) {
            handlePageChange(currentPage - 1);
        }
    };


    const isPrevDisabled = loader || currentPage === 1;
    const isNextDisabled = loader || data?.length !== 20;
    return (
        <div className="d-flex align-items-center gap-3  mt-4 ">

            <button
                onClick={handlePrev}
                disabled={isPrevDisabled}
                className="theme-btn gap-1 text-nowrap d-flex align-items-center"
                style={{ cursor: isPrevDisabled ? 'not-allowed' : 'pointer', background: isPrevDisabled ? 'gray' : '' }}
            >
                <MdOutlineKeyboardDoubleArrowLeft style={{ marginTop: "1px" }} /> Prev
            </button>

            <span className="dot">
                {currentPage}
            </span>

            <button
                onClick={handleNext}
                disabled={isNextDisabled}
                className="theme-btn gap-1 d-flex align-items-center"
                style={{ cursor: isNextDisabled ? 'not-allowed' : 'pointer', background: isNextDisabled ? 'gray' : '' }}
            >
                Next <MdOutlineKeyboardDoubleArrowRight style={{ marginTop: "1px" }} />
            </button>
        </div>
    );
};

export default NewPagination;
